var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBillSide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12.188,
    viewBox: "0 0 16 12.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "barcode_1_",
    "data-name": "barcode (1)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8256",
    "data-name": "Path 8256",
    d: "M2.969,61H1.094A1.1,1.1,0,0,0,0,62.094v1.875a.469.469,0,1,0,.938,0V62.094a.156.156,0,0,1,.156-.156H2.969a.469.469,0,1,0,0-.937Z",
    transform: "translate(0 -61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8257",
    "data-name": "Path 8257",
    d: "M2.969,343.5H1.094a.156.156,0,0,1-.156-.156v-1.875a.469.469,0,0,0-.938,0v1.875a1.1,1.1,0,0,0,1.094,1.094H2.969a.469.469,0,1,0,0-.937Z",
    transform: "translate(0 -332.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8258",
    "data-name": "Path 8258",
    d: "M404.969,341a.469.469,0,0,0-.469.469v1.875a.156.156,0,0,1-.156.156h-1.875a.469.469,0,0,0,0,.938h1.875a1.1,1.1,0,0,0,1.094-1.094v-1.875A.469.469,0,0,0,404.969,341Z",
    transform: "translate(-389.437 -332.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8259",
    "data-name": "Path 8259",
    d: "M404.344,61h-1.875a.469.469,0,0,0,0,.938h1.875a.156.156,0,0,1,.156.156v1.875a.469.469,0,1,0,.938,0V62.094A1.1,1.1,0,0,0,404.344,61Z",
    transform: "translate(-389.437 -61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8260",
    "data-name": "Path 8260",
    d: "M60.938,129.907v-7.438a.469.469,0,1,0-.938,0v7.438a.469.469,0,1,0,.938,0Z",
    transform: "translate(-58.125 -120.094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8261",
    "data-name": "Path 8261",
    d: "M120.469,122a.469.469,0,0,0-.469.469v4.938a.469.469,0,0,0,.938,0v-4.938A.469.469,0,0,0,120.469,122Z",
    transform: "translate(-116.25 -120.094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8262",
    "data-name": "Path 8262",
    d: "M180.469,122a.469.469,0,0,0-.469.469v7.438a.469.469,0,1,0,.938,0v-7.438A.469.469,0,0,0,180.469,122Z",
    transform: "translate(-174.375 -120.094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8263",
    "data-name": "Path 8263",
    d: "M240.469,122a.469.469,0,0,0-.469.469v4.938a.469.469,0,0,0,.938,0v-4.938A.469.469,0,0,0,240.469,122Z",
    transform: "translate(-232.5 -120.094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8264",
    "data-name": "Path 8264",
    d: "M300.469,122a.469.469,0,0,0-.469.469v4.938a.469.469,0,1,0,.938,0v-4.938A.469.469,0,0,0,300.469,122Z",
    transform: "translate(-290.625 -120.094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8265",
    "data-name": "Path 8265",
    d: "M360.469,122a.469.469,0,0,0-.469.469v4.938a.469.469,0,1,0,.938,0v-4.938A.469.469,0,0,0,360.469,122Z",
    transform: "translate(-348.75 -120.094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8266",
    "data-name": "Path 8266",
    d: "M420.938,129.907v-7.438a.469.469,0,1,0-.937,0v7.438a.469.469,0,1,0,.938,0Z",
    transform: "translate(-406.875 -120.094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8267",
    "data-name": "Path 8267",
    d: "M120.469,343a.469.469,0,0,0-.469.469V344a.469.469,0,0,0,.938,0v-.531A.469.469,0,0,0,120.469,343Z",
    transform: "translate(-116.25 -334.188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8268",
    "data-name": "Path 8268",
    d: "M240.469,343a.469.469,0,0,0-.469.469V344a.469.469,0,0,0,.938,0v-.531A.469.469,0,0,0,240.469,343Z",
    transform: "translate(-232.5 -334.188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8269",
    "data-name": "Path 8269",
    d: "M300.469,343a.469.469,0,0,0-.469.469V344a.469.469,0,0,0,.938,0v-.531A.469.469,0,0,0,300.469,343Z",
    transform: "translate(-290.625 -334.188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8270",
    "data-name": "Path 8270",
    d: "M360.469,343a.469.469,0,0,0-.469.469V344a.469.469,0,0,0,.938,0v-.531A.469.469,0,0,0,360.469,343Z",
    transform: "translate(-348.75 -334.188)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillSide);
export default __webpack_public_path__ + "static/media/billSide.92d221063f7b15f6d1303b0c66c94a5d.svg";
export { ForwardRef as ReactComponent };